import { Injectable } from '@angular/core';
import { CustomReport } from '@ng-cloud/badger-core/models/custom-report';
import { ApiService } from '@ng-cloud/badger-core/services/api.service';
import { Observable } from 'rxjs';

@Injectable()
export class CustomReportsService extends ApiService {

  /**
   *
   */
  getCustomReports(params?: any): Observable<CustomReport[]> {
    return this.list(CustomReport, 'custom_reports', params, 300);
  }
}
